<template>
  <bim-textarea
    width="100%"
    :value="value"
    @input="v => $emit('input', v)"
    :placeholder="placeholder"
    formKey="value"
    :formModel="_self"
    @blur="validate"
    height="100%"
    class="flex-grow-1"
  />
</template>

<script>
import validationMixin from '../validation.mixin'
import bimTextarea from '@/components/form/bimTextarea/bimTextarea'
export default {
  name: 'FieldTextarea',
  mixins: [validationMixin],
  components: {
    bimTextarea,
  },
  props: {
    value: String,
    placeholder: String,
  }
}
</script>

<style scoped lang="scss">

</style>
